import { hideModal } from "./modal";

export const initContactForm = () => {
  const initSelect = () => {
    document.querySelectorAll('select.wpcf7-form-control')
    .forEach((el) => {
      let placeholderOption = el.querySelector('option');
      if(placeholderOption && !placeholderOption.value){
        placeholderOption.setAttribute('disabled', true)
        placeholderOption.setAttribute('selected', true)
        el.classList.add('placeholder')
        el.addEventListener('change', () => { el.classList.remove('placeholder') })
      }
    })
  }
  initSelect()
  document.addEventListener( 'wpcf7mailsent', (ev) => {
    initSelect()
    const modal = ev.target.closest('.modal[data-type="modal-contact-form"]')
    setTimeout(() => {
      if(modal){hideModal(modal)}
    }, 5000)
  })
  document.addEventListener( 'wpcf7submit', (ev) => {
    let modalContent = ev.target.closest('.modal__content')
    if(modalContent) setTimeout(() => modalContent.scrollTo(0, modalContent.scrollHeight), 0)
  })
}
